/* eslint-disable react/prop-types */
/* eslint-disable no-undef */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import sharedConfig from '../../../../sharedConfig';

class ListingNotFound extends React.Component {
  render() {
    const { brand } = this.props;
    let homePage = sharedConfig.brandUrls[brand];
    if (brand === sharedConfig.brands.zillow) {
      homePage = `${homePage}/renting`;
    }

    return (
      <div className="ListingNotFound">
        <div className="stacked-lg" />
        <Text type="h3" className="stacked-md">
          There was a problem.
        </Text>
        <Text className="stacked-md">
          We were unable to find the listing. Something went wrong. We apologize for any inconvenience.
        </Text>
        <Text className="stacked-lg">Still looking for your next home?</Text>
        <Button
          type="primary"
          onClick={() => {
            window.location = homePage;
          }}
        >
          Continue your search
        </Button>
      </div>
    );
  }
}

ListingNotFound.propTypes = {
  brand: PropTypes.string,
};

const mapStateToProps = (state) => ({
  brand: state.app.brand,
});

export default connect(mapStateToProps)(ListingNotFound);
